export class ClickAndHold {
  target = null;
  callback = null;
  onEndCallback = null;
  holdTime = 0;

  isHeld = false;
  isActivelyHeld = false;
  activeHoldTimeout = null;

  /**
   * @param {HTMLElement} target The element to listen for clicks on
   * @param {function} callback The function to call when the element is clicked and held
   * @param {function} onEndCallback The function to call when the element is released
   * @param {number} holdTime The amount of time to hold the element before calling the callback
   *
   */
  constructor(target, callback = () => {}, onEndCallback = () => {}, holdTime = 500) {
    this.target = target;
    this.callback = callback;
    this.onEndCallback = onEndCallback;
    this.holdTime = holdTime;

    const START_EVENTS = ["mousedown", "touchstart"];
    const END_EVENTS = [
      "mouseup",
      "mouseleave",
      "mouseout",
      "touchend",
      "touchcancel",
    ];

    START_EVENTS.forEach((event) => {
      this.target.addEventListener(event, this._onHoldStart.bind(this));
    });

    END_EVENTS.forEach((event) => {
      this.target.addEventListener(event, this._onHoldEnd.bind(this));
    });
  }

  _onHoldStart() {
    this.isHeld = true;

    this.activeHoldTimeout = setTimeout(() => {
      this.isActivelyHeld = true;
      this.callback();
    }, this.holdTime);
  }

  _onHoldEnd() {
    this.isHeld = false;
    
    clearTimeout(this.activeHoldTimeout);

    if (this.isActivelyHeld) {
      this.onEndCallback();
      this.isActivelyHeld = false;
      return;
    }
  }
}

export default ClickAndHold;
